import Image from "next/image";

export default function LoadingData() {
    return (
        <div
            role="status"
            aria-live="polite"
            className="bg-web flex min-h-[50vh] flex-col items-center justify-center gap-4 px-6 py-12 text-center"
        >
            <div className="h-[200px] w-[200px] max-w-full">
                <Image
                    src="https://eve-image.eveebook.com/image.eveebook/mascot/loading.gif"
                    alt=""
                    aria-hidden="true"
                    width={200}
                    height={200}
                    unoptimized
                    loading="eager"
                    className="h-full w-full object-contain motion-reduce:hidden"
                />
            </div>
            <p className="text-primary text-base">กำลังโหลดข้อมูล...</p>
        </div>
    );
}
